import type { FaireProductEntity } from "../../entity_types/product";

export const p_s9wr6shcxf: FaireProductEntity = {
  token: "p_s9wr6shcxf",
  type: "product",
  name: "Poppin Dice' - Rainbow Satisfying Fidget Toy, Rainbow Colors",
  brandToken: "b_83nqde8ah7",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/916fa3f5eef4e867813f923e77c72e0eb2dfa4a3dd18d5f5f8309fc4c98fcf39.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8eeb25e5052558adc1fc9896bc5ef9e12d942ed250885762a162804f0f5b3a3a.jpeg",
    "https://cdn.faire.com/fastly/bd027dab5158ba6e31335446855e9a5d18f8604b79487b5dd76299a6040a17b1.jpeg",
    "https://cdn.faire.com/fastly/a389f42fe723beae90236229fb847e4a7b64c1cbf70aa6c09427572b547b1918.jpeg",
    "https://cdn.faire.com/fastly/fc6b1ab4da24ef6283496d6bed840945327645b2611ab191229d12a6fa8b49c5.jpeg",
    "https://cdn.faire.com/fastly/70bad893253f56a7e756e411a77bedcd0cfa69d11a4493659eed37d63baca53f.jpeg",
    "https://cdn.faire.com/fastly/a872d946affce50de6ee69501f9e1d0af8131a83efa5e918894430cbe5910b5a.png",
    "https://cdn.faire.com/fastly/83e907f80677c23616dec3c610273925a91bd8150eef3a75bcea2924f499267a.jpeg",
    "https://cdn.faire.com/fastly/2d55f790e421471ccbbe493078159f6b4dc7d1497293deda47d62526c95ee2cf.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Rainbow-colored squishy cubes have nubbins on each face, arranged just like the dots on regular dice, making them fun to squeeze, bounce, roll, and pop. These dice provide a satisfying, rubbery sensory experience, making them the perfect fidget toy. Squish ‘em and roll ‘em to relieve stress and promote focus, and use the numbered sides to work on math skills like counting and simple arithmetic.\r\n\r\n• Age Grade: 3+\r\n• Product Dimensions/Weight: 2.1 L x 2.1 W x 2.1 H inches / 0.1 lb\r\n• Inner Pack Dimensions/Weight: 10.1 L x 7.3 W x 2.5 H / 2.6 lb\r\n• Made In: China\r\n• Batteries not required",
  tags: [],
  msrpDollars: 6.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:29.503Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
